export default __webpack_public_path__ + "static/media/FICHA TÉCNICA - PERA.61892c7a.pdf";